import angular from 'angular'
import webskedTasksComponent from './webskedTasks.component'

export default angular
  .module('ellipsis.webskedTasks', [])
  .component('webskedTasks', webskedTasksComponent)
